<script setup lang="ts">
  defineOptions({ inheritAttrs: false, name: 'CPCardv2' })

  const props = defineProps({
    id: {
      type: String,
      required: false,
      default: undefined,
    },
  })
</script>

<template>
  <div
    :id="props.id"
    class="w-full h-full min-h-0 flex flex-col bg-background p-4 overflow-hidden shadow-sm border border-solid border-default rounded-lg"
    v-bind="$attrs"
  >
    <!-- Sticky header: does not scroll -->
    <header v-if="$slots.header" class="flex-shrink-0 z-[1000]">
      <slot name="header" />
    </header>

    <!-- Scrollable body: stable scrollbar gutter; desktop bleed matches root p-4 -->
    <div class="cp-card-v2__scroll-body flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
      <slot />
    </div>

    <!-- Sticky footer: does not scroll -->
    <footer v-if="$slots.footer" class="flex-shrink-0 z-[1000]">
      <slot name="footer" />
    </footer>
  </div>
</template>

<style scoped>
  .cp-card-v2__scroll-body {
    scrollbar-gutter: stable;
    box-sizing: border-box;
  }

  @media (min-width: 768px) {
    .cp-card-v2__scroll-body {
      width: calc(100% + 2rem);
      max-width: calc(100% + 2rem);
      margin-inline: -1rem;
      padding-inline: 1rem;
    }
  }
</style>
